import { observable } from 'rewire-core';
import batchModeModel from './BatchModeModel';

export class BatchPageModel {
  constructor() {
  }

  reset() {
    if (batchModeModel.isMode('Create')) {
    }
  }
}

const batchPageModel = observable(new BatchPageModel());
export default batchPageModel;
